export const orientationList = [
  {
    value: 'horizontal',
  },
  {
    value: 'vertical',
  },
]
